/* RegistrationNamespaces.js */

"use strict";
module.exports = {
    GAME_CENTER_SECTION: "App.GameConsole.Section.GameCenter",

    /****************/
    /* DEVICE PARTS */
    /****************/

    IOT_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.IOTDeviceExplorer",

    /*** DEVICE EXPLORER ***/

    DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.DeviceExplorer",
    DEVICE_EXPLORER_LMRB: "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer",
    DEVICE_EXPLORER_STATUS_BAR:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.StatusBar",

    SITE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.SiteExplorer",
    SITE_EXPLORER_LMRB: "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer",

    /*** DEVICE EXPLORER - CONFIG DRIFT & AUDIT ONLY ***/

    CONFIG_DRIFT_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.ConfigAudit.DeviceExplorer",

    /*** DEVICE EXPLORER SWITCHERS ***/

    DEVICE_EXPLORER_SWITCH_TO_AUDIT_POLICY:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToAuditPolicy",
    DEVICE_EXPLORER_SWITCH_TO_OS_PLAN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToOsPlan",
    DEVICE_EXPLORER_SWITCH_TO_OS_CATALOG:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToOsCatalog",
    DEVICE_EXPLORER_SWITCH_TO_DATA_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToDataExplorer",
    DEVICE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToNetworkDiscoveryExplorer",
    DEVICE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToIOTDeviceExplorer",
    DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.SwitchToPlatformExplorer",

    DEVICE_EXPLORER_SWITCH_TO_SITE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Views.SwitchToSiteExplorer",

    /*** DEVICE EXPLORER VIEWS ***/

    DEVICE_EXPLORER_VIEW_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Views.Grid",
    SITE_EXPLORER_VIEW_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Views.Grid",
    SITE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Views.SwitchToNetworkDiscovery",

    /*** DEVICE EXPLORER VIEWS - CONFIG DRIFT & AUDIT ALIAS ***/

    /** IOT DEVICE EXPLORER */

    IOT_DEVICE_EXPLORER_VIEW_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.Grid",
    IOT_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToDeviceExplorer",
    IOT_DEVICE_EXPLORER_SWITCH_TO_SITE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToSiteExplorer",
    IOT_DEVICE_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToPlatformExplorer",
    IOT_DEVICE_EXPLORER_SWITCH_TO_NETWORK_DISCOVERY_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToNetworkDiscoveryExplorer",
    IOT_SWITCH_TO_DATA_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToDataExplorer",
    IOT_SWITCH_TO_OS_PLAN_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToOSPlanExplorer",
    IOT_SWITCH_TO_CATALOG_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Views.SwitchToCatalogExplorer",

    /** IOT DEVICE EXPLORER */

    CONFIG_AUDIT_DEVICE_VIEW_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.ConfigAudit.DeviceExplorer.Views.Grid",

    /*** SITE EXPLORER ACTIONS ***/
    SITE_EXPLORER_ACTION_CREATE_SITE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.Create",
    SITE_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.Delete",
    SITE_EXPLORER_ACTION_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.Export",
    SITE_EXPLORER_ACTION_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.Import",
    SITE_EXPLORER_ACTION_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.Edit",
    SITE_EXPLORER_ACTION_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.Clone",
    SITE_EXPLORER_ACTION_MULTIEDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.MultiEdit",
    SITE_EXPLORER_ACTION_AUTO_ASSIGNMENT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Actions.AutoAssignment",

    /*** DEVICE EXPLORER ACTIONS ***/

    DEVICE_EXPLORER_ACTIONS_GLOB:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.*",
    DEVICE_EXPLORER_ACTION_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Export",
    DEVICE_EXPLORER_ACTION_REPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Report",

    /*** DEVICE EXPLORER ACTIONS - DEVICE MANAGER ONLY ***/

    DEVICE_EXPLORER_ACTION_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Create",
    DEVICE_EXPLORER_ACTION_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Clone",
    DEVICE_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Delete",
    DEVICE_EXPLORER_ACTION_DISCOVERY:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Discovery",
    DEVICE_EXPLORER_ACTION_ADHOC_QUERY:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.AdhocQuery",
    DEVICE_EXPLORER_ACTION_QUALIFY_CVES:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.QualifyCves",
    DEVICE_EXPLORER_ACTION_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Import",
    DEVICE_EXPLORER_ACTION_MULTIEDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.MultiEdit",
    DEVICE_EXPLORER_ACTION_UPDATE_CISCO:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.UpdateCiscoSupportData",
    DEVICE_EXPLORER_ACTION_BACKUP:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Backup",
    DEVICE_EXPLORER_ACTION_RESTORE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Restore",
    DEVICE_EXPLORER_ACTION_LINK_AND_SYNC:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.LinkAndSync",

    /*** DEVICE EXPLORER ACTIONS - CONFIG DRIFT & AUDIT ONLY ***/

    /** IoT Device Explorer Actions */

    IOT_DEVICE_EXPLORER_ACTION_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.Export",
    IOT_DEVICE_EXPLORER_ACTION_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.Import",
    IOT_DEVICE_EXPLORER_ACTION_LINK_AND_SYNC:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.LinkAndSync",
    IOT_DEVICE_EXPLORER_ACTION_MULTIEDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.MultiEdit",
    IOT_DEVICE_EXPLORER_ACTION_REPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.Report",
    IOT_DEVICE_EXPLORER_ACTION_COPY:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.Copy",
    IOT_DEVICE_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.Delete",
    IOT_DEVICE_EXPLORER_ACTION_OFFLINE_DISCOVERY_DOWNLOAD:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.OfflineDiscoveryDownload",
    IOT_DEVICE_EXPLORER_ACTION_OFFLINE_DISCOVERY_UPLOAD:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.OfflineDiscoveryUpload",
    IOT_DEVICE_EXPLORER_ACTION_ADD_OS_PLAN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IOTDeviceExplorer.Actions.AddOdmOsPlan",

    /** IoT Device Explorer Actions */

    DEVICE_EXPLORER_ACTION_CAPTURE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.Capture",
    DEVICE_EXPLORER_ACTION_SET_DEFAULT_CONFIG:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.SetDefaultConfig",
    DEVICE_EXPLORER_ACTION_CONFIGURE_AUDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.ConfigureAudit",

    /*** DEVICE EXPLORER ACTIONS - OS MANAGER ONLY ***/

    DEVICE_EXPLORER_ACTION_CREATE_OS_PLAN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.CreateOsPlan",
    DEVICE_EXPLORER_ACTION_REBOOT_DEVICE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DeviceExplorer.Actions.RebootDevice",

    /*** DEVICE EDITOR ***/

    DEVICE_INSTANCE_EDITOR: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor",
    SITE_INSTANCE_EDITOR: "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor",

    /*** DEVICE EDITOR VIEWS ***/

    DIE_VIEWS_GLOB: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.*",
    DIE_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Details",
    DIE_VIEW_DETAILS_SUBVIEW_HA_GROUP:
        "App.GameConsole.Section.GameCenter.DeviceInstanceEditor.Views.Details.Subview.HaGroup",
    DIE_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Activity",
    DIE_VIEW_RESTORE:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Restore",
    DIE_VIEW_AUDIT_SUMMARY:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.AuditSummary",

    SIE_VIEWS_GLOB: "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Views.*",
    SIE_VIEW_DETAILS: "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Views.Details",
    SIE_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Views.Activity",
    SIE_VIEW_MULTIEDIT:
        "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Views.SiteMultiEdit",
    SIE_VIEW_SITES: "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Views.SitesView",
    SIE_VIEW_DEVICES: "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Views.Devices",

    SIE_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.SiteInstanceEditor.Actions.Delete",

    /*** DEVICE EDITOR VIEWS - DEVICE MANAGER ONLY ***/

    DIE_VIEW_MULTIEDIT:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.DeviceMultiEdit",
    DIE_VIEW_EOX_BULLETIN:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.EoxBulletinView",
    DIE_VIEW_SMARTNET_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.SmartnetDetailsView",
    DIE_VIEW_ADVISORY_SUMMARY:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.AdvisorySummaryView",
    DIE_VIEW_ADVISORY_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.AdvisoryDetailsView",
    DIE_VIEW_EXPOSURE:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.ExposureView",
    DIE_VIEW_EXPOSURE_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.ExposureDetailsView",

    /*** DEVICE EDITOR VIEWS - CONFIG DRIFT & AUDIT ONLY ***/

    DIE_VIEW_COMPARE:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Compare",
    DIE_VIEW_SNAPSHOT:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Snapshot",
    DIE_VIEW_EDIT_SNAPSHOT:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.EditSnapshot",
    DIE_VIEW_CONFIG: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Config",
    DIE_VIEW_STATE: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.State",
    DIE_VIEW_NOTES: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Notes",
    DIE_VIEW_JOB: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Job",
    DIE_VIEW_LOGS: "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Logs",

    /*** DEVICE EDITOR ACTIONS - DEVICE MANAGER ONLY ***/

    DIE_ACTION_DISCOVERY:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Actions.Discovery",
    DIE_ACTION_BACKUP:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Actions.Backup",
    DIE_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Actions.Delete",

    /*** DEVICE EDITOR ACTIONS - CONFIG DRIFT & AUDIT ONLY ***/

    DIE_ACTION_CONFIG_AUDIT:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Actions.ConfigAudit",
    DIE_ACTION_CAPTURE:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Actions.Capture",
    DIE_ACTION_SET_DEFAULT_CONFIG:
        "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Actions.SetDefaultConfig",

    /***************************/
    /* NETWORK DISCOVERY PARTS */
    /***************************/

    /***  NETWORK DISCOVERY EDITOR ***/

    NETWORK_DISCOVERY_EDITOR: "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor",

    /***  NETWORK DISCOVERY EDITOR VIEWS ***/

    NETWORK_DISCOVERY_EDITOR_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor.Views.Details",
    NETWORK_DISCOVERY_EDITOR_VIEW_HISTORY:
        "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor.Views.History",
    NETWORK_DISCOVERY_EDITOR_SUBVIEW_EXECUTION_LOG:
        "App.GameConsole.Section.GameCenter.NetworkDiscoveryEditor.Views.History.Subview.ExecutionLog",
    NETWORK_DISCOVERY_EDITOR_VIEW_RESULTS:
        "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor.Views.Results",
    NETWORK_DISCOVERY_EDITOR_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor.Views.Activity",
    NETWORK_DISCOVERY_EDITOR_SUBVIEW_RESULTS_LOGS:
        "App.GameConsole.Section.Editors.NetworkDiscoveryEditor.Views.Results.Subview.Logs",

    NETWORK_DISCOVERY_EDITOR_ACTION_RUN:
        "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor.Actions.RunNetworkDiscovery",
    NETWORK_DISCOVERY_EDITOR_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.NetworkDiscoveryEditor.Actions.Delete",

    /*** Ad-hoc Query Editor */
    ADHOC_QUERY_EDITOR: "App.GameConsole.Section.GameCenter.Editors.AdhocQueryEditor",

    /*** Ad-hoc Query Views */
    ADHOC_QUERY_EDITOR_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.AdhocQueryEditor.Views.Details",

    /****************************** */
    /* Platform Explorer PARTS */
    /****************************** */

    /** Platform Editor */
    ODM_OS_PLATFORM_EDITOR: "App.GameConsole.Section.GameCenter.Editors.OdmOsPlatformEditor",

    /***  NETWORK DISCOVERY EDITOR VIEWS ***/

    ODM_OS_PLATFORM_EDITOR_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.OdmOsPlatformEditor.Views.Details",
    ODM_OS_PLATFORM_EDITOR_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.OdmOsPlatformEditor.Views.Activity",
    ODM_OS_PLATFORM_EDITOR_SUBVIEW_ACTIVITY_LOGS:
        "App.GameConsole.Section.GameCenter.OdmOsPlatformEditor.Views.Activity.Subview.Logs",

    /*** Platform Editor Actions ***/

    ODM_OS_PLATFORM_EDITOR_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.OdmOsPlatformEditor.Actions.Delete",

    ODM_OS_PLATFORM_EDITOR_ACTIONS_UPLOAD_IMAGE:
        "App.GameConsole.Section.GameCenter.Editors.OdmOsPlatformEditor.Actions.UploadImage",

    ODM_OS_PLATFORM_EDITOR_ACTIONS_ADD_IMAGES:
        "App.GameConsole.Section.GameCenter.Editors.OdmOsPlatformEditor.Actions.AddImages",

    /*** Platform Explorer ***/

    PLATFORM_EXPLORER_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.PlatformExplorer",

    PLATFORM_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Views.Grid",

    PLATFORM_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Views.SwitchToDeviceExplorer",
    PLATFORM_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Views.SwitchToIoTDeviceExplorer",
    PLATFORM_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Views.SwitchToIotOsPlanExplorer",
    PLATFORM_EXPLORER_SWITCH_TO_OS_PLAN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Views.SwitchToOsPlan",
    PLATFORM_EXPLORER_SWITCH_TO_OS_CATALOG:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Views.SwitchToOsCatalog",

    /*** PLATFORM EXPLORER ACTIONS ***/

    PLATFORM_EXPLORER_ACTION_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Actions.Create",
    PLATFORM_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Actions.Delete",
    PLATFORM_EXPLORER_ACTION_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Actions.Edit",
    PLATFORM_EXPLORER_ACTION_ADD_IMAGES:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Actions.AddImages",
    PLATFORM_EXPLORER_ACTION_ADD_INSTRUCTIONS:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Actions.AddInstructions",
    PLATFORM_EXPLORER_ACTION_FIND_IMAGES:
        "App.GameConsole.Section.GameCenter.LmrbComponents.PlatformExplorer.Actions.FindImages",

    /*****************************/
    /* OS CATALOG EXPLORER PARTS */
    /*****************************/

    /*** OS CATALOG EXPLORER ***/

    OS_CATALOG_EXPLORER_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.OsCatalogExplorer",

    /*** OS CATALOG EXPLORER SWITCHER ***/

    OS_CATALOG_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsCatalogExplorer.Views.SwitchToDeviceExplorer",
    OS_CATALOG_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsCatalogExplorer.Views.SwitchToIoTDeviceExplorer",
    OS_CATALOG_EXPLORER_SWITCH_TO_PLATFORM_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsCatalogExplorer.Views.SwitchToPlatformExplorer",

    /*** OS CATALOG EXPLORER VIEWS ***/

    OS_CATALOG_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsCatalogExplorer.Views.Grid",

    /*** OS CATALOG EXPLORER ACTIONS ***/

    CATALOG_EXPLORER_ACTION_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.CatalogExplorer.Actions.CreateCatalog",
    CATALOG_EXPLORER_ACTION_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.CatalogExplorer.Actions.EditCatalog",
    CATALOG_EXPLORER_ACTION_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.CatalogExplorer.Actions.CloneCatalog",
    CATALOG_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.CatalogExplorer.Actions.DeleteCatalog",
    CATALOG_EXPLORER_ACTION_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.CatalogExplorer.Actions.ExportCatalog",

    /*** OS CATALOG EDITOR ***/

    OS_CATALOG_EDITOR: "App.GameConsole.Section.GameCenter.Editors.OsCatalogEditor",

    /*** OS CATALOG EDITOR VIEWS ***/

    OS_CATALOG_EDITOR_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.OsCatalogEditor.Views.Details",
    OS_CATALOG_EDITOR_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.OsCatalogEditor.Views..Activity",

    /*** OS CATALOG EDITOR ACTIONS ***/

    OS_CATALOG_EDITOR_ACTIONS_EXPORT:
        "App.GameConsole.Section.GameCenter.Editors.OsCatalogEditor.Actions.Export",
    OS_CATALOG_EDITOR_ACTIONS_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.OsCatalogEditor.Actions.Delete",

    /***************/
    /* AUDIT PARTS */
    /***************/

    /*** AUDIT EXPLORER ***/

    AUDIT_POLICY_EXPLORER_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.AuditPolicyExplorer",

    /*** AUDIT EXPLORER SWITCHER ***/

    AUDIT_POLICY_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Views.SwitchToDeviceExplorer",

    SITE_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Views.SwitchToDeviceExplorer",

    SITE_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.SiteExplorer.Views.SwitchToIotDeviceExplorer",

    /*** AUDIT EXPLORER VIEWS ***/

    AUDIT_POLICY_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Views.Grid",

    /*** AUDIT EXPLORER ACTIONS ***/

    AUDIT_POLICY_EXPLORER_ACTIONS_GLOB:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Actions.*",
    AUDIT_POLICY_EXPLORER_ACTION_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Actions.Create",
    AUDIT_POLICY_EXPLORER_ACTION_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Actions.Clone",
    AUDIT_POLICY_EXPLORER_ACTION_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Actions.Import",
    AUDIT_POLICY_EXPLORER_ACTION_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Actions.Export",
    AUDIT_POLICY_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.AuditPolicyExplorer.Actions.Delete",

    /*** AUDIT POLICY EDITOR ***/

    AUDIT_POLICY_EDITOR: "App.GameConsole.Section.GameCenter.Editors.AuditPolicyEditor",

    /*** AUDIT POLICY EDITOR VIEWS ***/

    AUDIT_POLICY_EDITOR_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.Details",
    AUDIT_POLICY_EDITOR_VIEW_RESULTS:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.Results",
    AUDIT_POLICY_EDITOR_VIEW_HISTORY:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.History",
    AUDIT_POLICY_EDITOR_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.Activity",

    AUDIT_POLICY_EDITOR_VIEW_VERSIONS:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.Versions",
    AUDIT_POLICY_EDITOR_SUBVIEW_COMPARE:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.Versions.Subview.Compare",

    AUDIT_POLICY_EDITOR_SUBVIEW_EXECUTION_LOG:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.History.Subview.ExecutionLog",
    AUDIT_POLICY_EDITOR_SUBVIEW_TARGET_DEVICES_LIST:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.History.Subview.TargetDevicesList",
    AUDIT_POLICY_EDITOR_SUBVIEW_DETAILS_VIEW:
        "App.GameConsole.Section.GameCenter.AuditPolicyEditor.Views.History.Subview.PolicyDetailsSubview",

    /*** AUDIT POLICY EDITOR ACTIONS ***/

    AUDIT_POLICY_EDITOR_ACTIONS_GLOB:
        "App.GameConsole.Section.GameCenter.Editors.AuditPolicyEditor.Actions.*",
    AUDIT_POLICY_EDITOR_ACTIONS_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.AuditPolicyEditor.Actions.Delete",

    /**********************/
    /* WORK TRIGGER PARTS */
    /**********************/

    /*** WORK TRIGGER EXPLORER ***/

    WORK_TRIGGER_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.WorkTriggerExplorer",

    /*** WORK TRIGGER EXPLORER VIEWS ***/

    WORK_TRIGGER_EXPLORER_VIEW_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Views.Grid",

    /*** WORK TRIGGER EXPLORER ACTIONS ***/

    WORK_TRIGGER_EXPLORER_ACTIONS_GLOB:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Actions.*",
    WORK_TRIGGER_EXPLORER_ACTION_RUN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Actions.Run",
    WORK_TRIGGER_EXPLORER_ACTION_PAUSE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Actions.Pause",
    WORK_TRIGGER_EXPLORER_ACTION_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Actions.Create",
    WORK_TRIGGER_EXPLORER_ACTION_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Actions.Clone",
    WORK_TRIGGER_EXPLORER_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.WorkTriggerExplorer.Actions.Delete",

    /*** WORK TRIGGER EDITOR ***/

    WORK_TRIGGER_INSTANCE_EDITOR:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor",

    /*** WORK TRIGGER EDITOR VIEWS ***/

    WTE_VIEWS_GLOB: "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.*",
    WTE_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.Details",
    WTE_VIEW_HISTORY:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.History",
    WTE_VIEW_FUTURES:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.Futures",
    WTE_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.Activity",
    WTE_VIEW_WORK:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.Work",
    WTE_VIEW_LOGS:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.Logs",
    WTE_VIEW_TARGET_RESULTS:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Views.Targets",

    /*** WORK TRIGGER EDITOR ACTIONS ***/

    WTE_ACTION_RUN:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Actions.Run",
    WTE_ACTION_PAUSE:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Actions.Pause",
    WTE_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.WorkTriggerInstanceEditor.Actions.Delete",

    /****************/
    /* WIZARD PARTS */
    /****************/

    /*** WIZARD EXPLORER ***/

    WIZARD_EXPLORER_LMRB: "LmrbComponents.WizardExplorer",

    /*** WIZARD EXPLORER VIEWS ***/

    WIZARD_EXPLORER_VIEW_LIST: "LmrbComponents.WizardExplorer.Views.List",

    /*** WIZARD EDITOR ***/

    WIZARD_INSTANCE_EDITOR: "Editors.WizardInstanceEditor",

    /*** WIZARD EDITOR VIEWS ***/

    WIZARD_INSTANCE_EDITOR_EXECUTION_VIEW: "Editors.WizardInstanceEditor.Views.Execution",

    /*****************/
    /* PACKAGE PARTS */
    /*****************/

    /*** PACKAGE EXPLORER ***/

    PACKAGE_EXPLORER_LMRB: "LmrbComponents.PackageExplorer",
    PACKAGE_EXPLORER_STATUS_BAR: "LmrbComponents.PackageExplorer.PackageStatus",

    /*** PACKAGE EDITOR ***/

    PACKAGE_EDITOR: "Editors.PackageEditor",

    /*****************/
    /* OS PLAN PARTS */
    /*****************/

    /*** OS PLAN EXPLORER ***/

    OS_PLAN_EXPLORER_LMRB: "App.GameConsole.Section.GameCenter.EntityLmrbComponents.OsPlanExplorer",
    OS_MANAGER_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.OsDeviceExplorer",
    OS_MANAGER_IOT_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.OSMExplorer.IoTDeviceExplorer",

    /*** OS PLAN EXPLORER SWITCHER ***/

    OS_PLAN_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Views.SwitchToDeviceExplorer",
    OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Views.SwitchToIotDeviceExplorer",
    OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Views.SwitchToPlatformExplorer",
    OS_PLAN_EXPLORER_SWITCH_TO_IOT_OS_PLAN_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Views.SwitchToIotOsPlanExplorer",

    /*** OS PLAN EXPLORER VIEWS ***/

    OS_PLAN_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Views.Grid",
    OS_PLAN_STATUS_BAR:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Views.StatusBar",

    /*** OS PLAN EXPLORER ACTIONS ***/

    OS_PLAN_EXPLORER_ACTIONS_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Actions.Create",
    OS_PLAN_EXPLORER_ACTIONS_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Actions.Delete",
    OS_PLAN_EXPLORER_ACTIONS_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Actions.Clone",
    OS_PLAN_EXPLORER_ACTIONS_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Actions.Export",
    OS_PLAN_EXPLORER_ACTIONS_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Actions.Edit",
    OS_PLAN_EXPLORER_ACTIONS_RUN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.OsPlanExplorer.Actions.Run",

    /*** OS PLAN EDITOR ***/

    OS_PLAN_EDITOR: "App.GameConsole.Section.GameCenter.Editors.OsPlanEditor",

    /*** OS PLAN EDITOR VIEWS ***/

    OS_PLAN_EDITOR_VIEW_DETAILS: "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Details",
    OS_PLAN_EDITOR_VIEW_RESULTS: "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Results",
    OS_PLAN_EDITOR_VIEW_ACTIVITY: "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Activity",
    OS_PLAN_EDITOR_SUBVIEW_IMAGE_DETAILS:
        "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Details.Subview.ImageDetails",
    OS_PLAN_EDITOR_SUBVIEW_VALIDATE:
        "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Details.Subview.Validate",
    OS_PLAN_EDITOR_SUBVIEW_ACTIVITY_LOGS:
        "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Activity.Subview.Logs",
    OS_PLAN_EDITOR_SUBVIEW_RESULTS_LOGS:
        "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Results.Subview.Logs",
    OS_PLAN_EDITOR_SUBVIEW_MANAGE_DEVICE:
        "App.GameConsole.Section.GameCenter.OsPlanEditor.Views.Details.Subview.ManageDetails",

    /*** OS PLAN EDITOR ACTIONS ***/

    OS_PLAN_EDITOR_ACTIONS_DELETE: "App.GameConsole.Section.GameCenter.OsPlanEditor.Actions.Delete",
    OS_PLAN_EDITOR_ACTIONS_RUN: "App.GameConsole.Section.GameCenter.OsPlanEditor.Actions.Run",

    /**************/
    /* FILE PARTS */
    /**************/

    /*** FILE EXPLORER ***/

    FILE_EXPLORER_LMRB: "App.GameConsole.Section.GameCenter.EntityLmrbComponents.FileExplorer",

    /*** FILE EXPLORER VIEWS ***/

    FILE_EXPLORER_GRID: "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Views.Grid",
    FILE_EXPLORER_STATUS_BAR:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Views.StatusBar",

    /*** FILE EXPLORER ACTIONS ***/

    FILE_EXPLORER_ACTION_CREATE_FILE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Actions.Create",
    FILE_EXPLORER_ACTION_DELETE_FILE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Actions.Delete",
    FILE_EXPLORER_ACTION_EDIT_FILE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Actions.Edit",
    FILE_EXPLORER_ACTION_CREATE_FOLDER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Actions.CreateFolder",
    FILE_EXPLORER_ACTION_DELETE_FOLDER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Actions.DeleteFolder",
    FILE_EXPLORER_ACTION_RENAME_FOLDER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.FileExplorer.Actions.RenameFolder",

    /*** FILE EDITOR ***/

    FILE_INSTANCE_EDITOR: "App.GameConsole.Section.GameCenter.Editors.FileInstanceEditor",

    /*** FILE EDITOR VIEWS ***/

    FIE_VIEW_DETAILS: "App.GameConsole.Section.GameCenter.Editors.FileInstanceEditor.Views.Details",
    FILE_VIEW_MULTIEDIT:
        "App.GameConsole.Section.GameCenter.Editors.FileInstanceEditor.Views.MultiEdit",
    FIE_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.FileInstanceEditor.Views.Activity",

    /*** FILE EDITOR ACTIONS ***/

    FIE_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.Editors.FileInstanceEditor.Actions.Delete",

    /**********************/
    /* DATA EXPLOER PARTS */
    /**********************/

    /*** DATA EXPLORER ***/

    DATA_EXPLORER_LMRB: "App.GameConsole.Section.GameCenter.EntityLmrbComponents.DataExplorer",

    /*** DATA EXPLORER VIEWS ***/

    DATA_EXPLORER_GRID: "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Views.Grid",
    DATA_EXPLORER_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.DataExplorer.DeviceExplorer",
    DATA_EXPLORER_IOT_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.DataExplorer.IoTDeviceExplorer",
    DATA_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Views.SwitchToDeviceExplorer",
    DATA_EXPLORER_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Views.SwitchToIoTDeviceExplorer",
    DATA_EXPLORER_DEVICE_VIEW_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.DeviceExplorer.Views.Grid",

    /*** DATA EXPLORER ACTIONS ***/

    DATA_EXPLORER_ACTIONS_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Create",
    DATA_EXPLORER_ACTIONS_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Delete",
    DATA_EXPLORER_ACTIONS_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Clone",
    DATA_EXPLORER_ACTIONS_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Export",
    DATA_EXPLORER_ACTIONS_EXPORTDATA:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.ExportData",
    DATA_EXPLORER_ACTIONS_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Import",
    DATA_EXPLORER_ACTIONS_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Edit",
    // DATA_EXPLORER_ACTIONS_RUN: "App.GameConsole.Section.GameCenter.LmrbComponents.DataExplorer.Actions.Run",

    /*** DATA EDITOR ***/

    DATA_INSTANCE_EDITOR: "App.GameConsole.Section.GameCenter.Editors.DataInstanceEditor",

    /*** DATA EDITOR VIEWS ***/

    DEIE_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.DataInstanceEditor.Views.Details",
    DEIE_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.Editors.DataInstanceEditor.Views.Activity",
    DEIE_VIEW_RESULT: "App.GameConsole.Section.GameCenter.Editors.DataInstanceEditor.Views.Result",

    /*** DATA EDITOR ACTIONS ***/

    /**
     * Network Discovery Grid
     */
    NETWORK_DISCOVERY_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Views.Grid",
    NETWORK_DISCOVERY_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Views.SwitchToDeviceExplorer",
    NETWORK_DISCOVERY_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Views.SwitchToIotDeviceExplorer",
    NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.NetworkDiscoveryExplorer",
    NETWORK_DISCOVERY_DEVICE_EXPLORER_ENTITY_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.NetworkDiscovery.DeviceExplorer",
    NETWORK_DISCOVERY_ACTION_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.Create",
    NETWORK_DISCOVERY_ACTION_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.Clone",
    NETWORK_DISCOVERY_ACTION_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.Delete",
    NETWORK_DISCOVERY_ACTION_RUN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.RunNetworkDiscovery",
    NETWORK_DISCOVERY_ACTION_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.EditNetworkDiscovery",
    NETWORK_DISCOVERY_ACTION_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.ExportNetworkDiscovery",
    NETWORK_DISCOVERY_ACTION_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Actions.ImportNetworkDiscovery",
    NETWORK_DISCOVERY_EXPLORER_SWITCH_TO_SITE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.NetworkDiscoveryExplorer.Views.SwitchToSiteExplorer",

    /*************************/
    /* VERSION CONTROL PARTS */
    /*************************/

    /*** VERSION CONTROL EXPLORER ***/

    VERSION_CONTROL_EXPLORER_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.VersionControlExplorer",

    /*** VERSION CONTROL EXPLORER VIEWS ***/

    VERSION_CONTROL_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.VersionControlExplorer.Views.Grid",

    /*** VERSION CONTROL EXPLORER ACTIONS ***/

    VERSION_CONTROL_ACTION_COMMIT_PUSH:
        "App.GameConsole.Section.GameCenter.LmrbComponents.VersionControlExplorer.Actions.CommitPush",

    /*** VERSION CONTROL EDITOR ***/

    VERSION_CONTROL_INSTANCE_EDITOR:
        "App.GameConsole.Section.GameCenter.Editors.VersionControlInstanceEditor",

    /*** VERSION CONTROL EDITOR VIEWS ***/

    VERSION_CONTROL_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.Editors.VersionControlInstanceEditor.Views.Details",

    /*********************/
    /* IOT OS PLAN PARTS */
    /*********************/

    /*** IOT OS PLAN PARTS */
    IOT_OS_PLAN_EXPLORER_LMRB:
        "App.GameConsole.Section.GameCenter.EntityLmrbComponents.IotOsPlanExplorer",
    IOT_OS_PLAN_EXPLORER_SWITCH_TO_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Views.SwitchToDeviceExplorer",
    IOT_OS_PLAN_SWITCH_TO_OS_PLAN_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Views.SwitchToOsPlanExplorer",
    IOT_OS_PLAN_SWITCH_TO_PLATFORM_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Views.SwitchToPlatformExplorer",
    IOT_OS_PLAN_SWITCH_TO_IOT_DEVICE_EXPLORER:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Views.SwitchToIotDeviceExplorer",
    IOT_OS_PLAN_EXPLORER_GRID:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Views.Grid",
    IOT_OS_PLAN_STATUS_BAR:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Views.StatusBar",
    IOT_OS_PLAN_EXPLORER_ACTIONS_CREATE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Create",
    IOT_OS_PLAN_EXPLORER_ACTIONS_DELETE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Delete",
    IOT_OS_PLAN_EXPLORER_ACTIONS_CLONE:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Clone",
    IOT_OS_PLAN_EXPLORER_ACTIONS_EXPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Export",
    IOT_OS_PLAN_EXPLORER_ACTIONS_EDIT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Edit",
    IOT_OS_PLAN_EXPLORER_ACTIONS_RUN:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Run",
    IOT_OS_PLAN_EXPLORER_ACTIONS_IMPORT:
        "App.GameConsole.Section.GameCenter.LmrbComponents.IotOsPlanExplorer.Actions.Import",

    /*** IoT OS PLAN EDITOR ***/

    IOT_OS_PLAN_EDITOR: "App.GameConsole.Section.GameCenter.Editors.IotOsPlanEditor",

    /***IoT OS PLAN EDITOR VIEWS ***/

    IOT_OS_PLAN_EDITOR_VIEW_DETAILS:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Details",
    IOT_OS_PLAN_EDITOR_VIEW_RESULTS:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Results",
    IOT_OS_PLAN_EDITOR_VIEW_ACTIVITY:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Activity",
    IOT_OS_PLAN_EDITOR_SUBVIEW_IMAGE_DETAILS:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Details.Subview.ImageDetails",
    IOT_OS_PLAN_EDITOR_SUBVIEW_VALIDATE:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Details.Subview.Validate",
    IOT_OS_PLAN_EDITOR_SUBVIEW_ACTIVITY_LOGS:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Activity.Subview.Logs",
    IOT_OS_PLAN_EDITOR_SUBVIEW_RESULTS_LOGS:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Results.Subview.Logs",
    IOT_OS_PLAN_EDITOR_SUBVIEW_MANAGE_DEVICE:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Views.Details.Subview.ManageDetails",

    /*** IoT OS PLAN EDITOR ACTIONS ***/

    IOT_OS_PLAN_EDITOR_ACTIONS_DELETE:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Actions.Delete",
    IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_DOWNLOAD:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Actions.OfflineUpgradeDownload",
    IOT_OS_PLAN_EDITOR_ACTIONS_OFFLINE_UPGRADE_UPLOAD:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Actions.OfflineUpgradeUpload",
    IOT_OS_PLAN_EDITOR_ACTIONS_UPLOAD_IMAGE:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Actions.UploadImage",
    IOT_OS_PLAN_EDITOR_ACTIONS_UPDATE_DEVICE_STATUSES:
        "App.GameConsole.Section.GameCenter.IotOsPlanEditor.Actions.UpdateDeviceStatuses",

    /*************/
    /* SOLUTIONS */
    /*************/

    CLASSIC_SOLUTION: "Solutions.classic",
    ROUTING_SOLUTION: "Solutions.Routing",
    WORKFLOW_EXPLORER: "Solutions.WorkflowExplorer",
    RPA_SOLUTION: "Solutions.rpa",
    TOPOLOGY_SOLUTION: "Solutions.topology",

    /**********************/
    /* SOLUTION UTILITIES */
    /**********************/

    CD_UTILITY_SOLUTION: "Solutions.Utility.ConfigDrift",
    DATA_EXPORT_UTILITY_SOLUTION: "Solutions.Utility.DataExport",
    OS_MANAGER_UTILITY_SOLUTION: "Solutions.Utility.OsManager",

    /***************************/
    /* SOLUTION ADMINISTRATION */
    /***************************/

    SETTINGS_ADMINISTRATION_SOLUTION: "Solutions.Administration.Settings",
    PACKAGE_ADMINISTRATION_SOLUTION: "Solutions.Administration.Packages",
    DEVICE_MANAGER_ADMINISTRATION_SOLUTION: "Solutions.Administration.DeviceManager",
    DASHBOARD_ADMINISTRATION_SOLUTION: "Solutions.Administration.Dashboard",
    WORK_TRIG_ADMINISTRATION_SOLUTION: "Solutions.Administration.WorkTriggers",
    FILE_SERVER_ADMINISTRATION_SOLUTION: "Solutions.Administration.FileServer",
    DATA_EXPLORER_ADMINISTRATION_SOLUTION: "Solutions.Administration.DataExplorer",
    VERSION_CONTROL_ADMINISTRATION_SOLUTION: "Solutions.Administration.VersionControl",
};
Object.freeze(module.exports);
